define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class OrderFormService
     */
    function OrderFormService($root, $q, $log, orderProvider, localStorageService) {
        var self = this;

        var ORDER_FORM_KEY = 'user.orderForm';
        var ORDER_FORM_KEY_EXPIRATION = 'user.orderForm.expirationDate';

        /**
         * Save locally the user network
         * @param  {Object} orderForm
         */
        function _saveLocally(orderForm) {
            localStorageService.set(ORDER_FORM_KEY, JSON.stringify(orderForm));
            localStorageService.set(
                ORDER_FORM_KEY_EXPIRATION,
                moment()
                    .add(1, 'days')
                    .format('YYYY-MM-DD')
            );
        }

        /**
         * Get the locally saved orderForm
         * @return {Object}
         */
        self.getLocally = function getLocally() {
            var orderForm = localStorageService.get(ORDER_FORM_KEY);
            var expirationDate = localStorageService.get(ORDER_FORM_KEY_EXPIRATION);

            expirationDate = expirationDate === '[]' ? null : expirationDate;
            orderForm = orderForm ? JSON.parse(orderForm) : orderForm;

            return {
                orderForm: orderForm,
                expirationDate: expirationDate
            };
        };

        /**
         * Get order form
         * @return {Promise}
         */
        self.getOrderForm = function getOrderForm() {
            var d = $q.defer();
            var orderFormKeys = self.getLocally();

            if (
                !$root.online ||
                (orderFormKeys.orderForm &&
                    orderFormKeys.expirationDate &&
                    moment(orderFormKeys.expirationDate) > moment())
            ) {
                $log.info('GET local order form');
                d.resolve(orderFormKeys.orderForm);
                return d.promise;
            }

            orderProvider.getOrderForm(moment().format('YYYY-MM-DD')).then(function(orderForm) {
                _saveLocally(orderForm);
                d.resolve(orderForm);
            }, d.reject.bind(d));

            return d.promise;
        };

        self.clearCache = function clearCache() {
            localStorageService.set(ORDER_FORM_KEY, JSON.stringify([]));
            localStorageService.set(ORDER_FORM_KEY_EXPIRATION, JSON.stringify([]));
        };

        return self;
    }

    OrderFormService.$inject = ['$rootScope', '$q', '$log', 'order', 'localStorageService'];

    angular.module('app.bdc.list.orderFormService', []).factory('orderFormService', OrderFormService);
});
